import * as z from "zod/v4";
import {
  billingChargeTypeSchema,
  transactionStatusSchema,
} from "./get-billing-charges-and-transactions";
import { billSchema } from "./get-bills";

const aggregatedChargeSchema_ = z.object({
  recordType: z.literal("charge"),
  type: billingChargeTypeSchema,
  chargeSubtype: z.string().nullish(),
  totalAmount: z.number(),
  currency: z.string(),
  count: z.number(),
});
export const aggregatedChargeSchema: z.ZodType<AggregatedChargeSchema> =
  aggregatedChargeSchema_;
export interface AggregatedChargeSchema
  extends z.infer<typeof aggregatedChargeSchema_> {}

const aggregatedTransactionSchema_ = z.object({
  recordType: z.literal("transaction"),
  status: transactionStatusSchema,
  totalAmount: z.number(),
  currency: z.string(),
  count: z.number(),
});
export const aggregatedTransactionSchema: z.ZodType<AggregatedTransactionSchema> =
  aggregatedTransactionSchema_;
export interface AggregatedTransactionSchema
  extends z.infer<typeof aggregatedTransactionSchema_> {}

const ledgerEntrySchema = z.union([
  aggregatedChargeSchema,
  aggregatedTransactionSchema,
]);
export type LedgerEntry = z.infer<typeof ledgerEntrySchema>;

const billingTransactionSchema_ = z.object({
  id: z.string(),
  amount: z.number(),
  currency: z.string(),
  status: transactionStatusSchema,
  shopifyChargeId: z.string().nullish(),
  stripeChargeId: z.string().nullish(),
  failureMessage: z.string().nullish(),
  createdAt: z.date(),
});
export const billingTransactionSchema: z.ZodType<BillingTransactionSchema> =
  billingTransactionSchema_;
export interface BillingTransactionSchema
  extends z.infer<typeof billingTransactionSchema_> {}

const getBillDetailsInput_ = z.object({ billId: z.string() });
export const getBillDetailsInput: z.ZodType<GetBillDetailsInput> =
  getBillDetailsInput_;
export interface GetBillDetailsInput
  extends z.infer<typeof getBillDetailsInput_> {}

const getBillDetailsOutput_ = z.object({
  bill: billSchema,
  ledgerEntries: z.array(ledgerEntrySchema),
  transactions: z.array(billingTransactionSchema),
});
export const getBillDetailsOutput: z.ZodType<GetBillDetailsOutput> =
  getBillDetailsOutput_;
export interface GetBillDetailsOutput
  extends z.infer<typeof getBillDetailsOutput_> {}

export const getBillDetails = {
  name: "getBillDetails" as const,
  input: getBillDetailsInput,
  output: getBillDetailsOutput,
};
